import { createContext, useContext } from "react";
import type { CallPip } from "../hooks/useCallPictureInPicture";

/**
 * The call's single picture-in-picture controller, provided once per call by
 * the shell-level call renderer so any control (the bottom-bar button, the
 * mobile overflow menu) drives the same window. Null outside a call.
 */
export const CallPipContext = createContext<CallPip | null>(null);

/** The current call's PiP controller, or null when there is no call. */
export function useCallPip(): CallPip | null {
  return useContext(CallPipContext);
}
